<template>
    <div class="stepsdemo-content">
        <Card>
            <template v-slot:title>
                Anagrafica
            </template>
            <template v-slot:subtitle>
                Inserisci i dati
            </template>
            <template v-slot:content>
                <div class="formgrid grid">         
                    <div class="p-field col-12 md:col-6">
                        <label for="name">Nome e Cognome (Ragsoc)</label><br>
                        <InputText id="name" v-model="name" :class="['inputfield w-full',{'p-invalid': validationErrors.name && submitted}]" />
                        <small v-show="validationErrors.name && submitted" class="p-error">Campo richiesto.</small>
                    </div>     
                    <div class="p-field col-12 md:col-6">
                        <label for="mobile">Cellulare</label><br>                   
                        <InputMask id="mobile" mask="9999999999" v-model="mobile" :class="['inputfield w-full',{'p-invalid': validationErrors.mobile && submitted}]" />
                        <small v-show="validationErrors.mobile && submitted" class="p-error">Campo richiesto.</small>
                    </div>               
                    <div class="p-field col-12 md:col-6">
                        <label for="email">Email</label><br>
                        <InputText id="email" v-model="email" :class="['inputfield w-full',{'p-invalid': validationErrors.email || validationErrors.isEmail && submitted}]" />
                        <div v-show="validationErrors.email && submitted" class="p-error">Campo richiesto.</div>
                        <div v-show="validationErrors.isEmail && submitted" class="p-error">Formato errato.</div>
                    </div>
                    <div class="p-field col-12 md:col-6">
                        <label for="note">Note</label><br>
                        <InputText id="note" v-model="note" :class="['inputfield w-full',{'p-invalid': validationErrors.note && submitted}]" />
                        <div v-show="validationErrors.note && submitted" class="p-error">Campo richiesto.</div>
                    </div>
                    <div class="p-field col-12 md:col-6 flex mt-3">
                        <label class="col-7">Abilita selezione della fattura bimestrale</label>
                        <div class="col-2 flex align-items-center">
                            <RadioButton v-model="abilita_scelta_bimestrale" inputId="radio_si_bimestrale" value="Si" />
                            <label for="radio_si_bimestrale" class="ml-2">Si</label>
                        </div>
                        <div class="col-2 flex align-items-center">
                            <RadioButton v-model="abilita_scelta_bimestrale" inputId="radio_no_bimestrale" value="No" />
                            <label for="radio_no_bimestrale" class="ml-2">No</label>
                        </div>
                    </div> 
                    <div class="p-field col-12 md:col-6 flex mt-3">
                        <label class="col-7">Abilita visualizzazione generatore offerte</label>
                        <div class="col-2 flex align-items-center">
                            <RadioButton v-model="abilita_visualizzazione_generatore_offerte" inputId="radio_si_generatore" value="Si" />
                            <label for="radio_si_generatore" class="ml-2">Si</label>
                        </div>
                        <div class="col-2 flex align-items-center">
                            <RadioButton v-model="abilita_visualizzazione_generatore_offerte" inputId="radio_no_generatore" value="No" />
                            <label for="radio_no_generatore" class="ml-2">No</label>
                        </div>
                    </div>
                    <div class="p-field col-12 md:col-6 flex mt-3">
                        <label class="col-7">Agente master</label>
                        <div class="col-2 flex align-items-center">
                            <RadioButton v-model="agente_master" inputId="radio_si_master" value="Si" />
                            <label for="radio_si_master" class="ml-2">Si</label>
                        </div>
                        <div class="col-2 flex align-items-center">
                            <RadioButton v-model="agente_master" inputId="radio_no_master" value="No" />
                            <label for="radio_no_master" class="ml-2">No</label>
                        </div>
                    </div>

                    <div v-if="agente_master === 'Si'" class="col-12 mt-4">
                        <p class="mandato-title mb-3">Carica il mandato dell'agente (opzionale)</p>
                        <div class="grid form-file align-items-start">
                            <div class="p-field col-12 md:col-6 mandato-field">
                                <label for="mandato-titolo">Titolo</label>
                                <InputText id="mandato-titolo" :modelValue="mandato.title" type="text" class="inputfield w-full mandato-input" disabled />
                            </div>
                            <div class="p-field col-12 md:col-6 mandato-field">
                                <label for="upload-mandato">File</label>
                                <div class="button-wrapper">
                                    <span :class="['label', { 'active': mandato.file.length > 0 }]">
                                        {{ mandato.file.length > 0 ? mandato.file[0].name : 'Seleziona File' }}
                                    </span>
                                    <input id="upload-mandato" type="file" ref="fileMandato" @change="handleMandatoUpload"
                                        :accept="`${Object.values(mandato.allowedType).join(', ')}`" />
                                </div>
                                <div class="allowed-format">
                                    Formati consentiti: {{ Object.keys(mandato.allowedType).join(', ') }}
                                </div>
                                <div v-show="validationErrors.mandatoType && submitted" class="p-error">Formato non consentito</div>
                            </div>
                        </div>
                    </div>

                    <div v-if="agente_master === 'No'" class="col-12 mt-4">
                        <p>Seleziona agenzia di appartenenza</p>
                        <Dropdown
                            v-model="id_parent"
                            :options="agenti"
                            :filter="true"
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Seleziona..."
                            :class="['inputfield w-full', {'p-invalid': validationErrors.id_parent && submitted}]"
                            :showClear="true"
                        />
                        <div v-show="validationErrors.id_parent && submitted" class="p-error">Campo richiesto.</div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="grid justify-content-between">
                    <i></i>
                    <Button  label="" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import {ref, watch, onMounted, getCurrentInstance} from 'vue';
import Card from 'primevue/card';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import InputMask from 'primevue/inputmask';
import Dropdown from 'primevue/dropdown';
import Service from '@/services/ask-pratiche/pratiche-wizard'


export default {
    components: {
        Card,
        InputText,
        Button,
        InputMask,
        Dropdown,
    },
     props: {
        formData: Object
    },
    setup (props, {emit}) {
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus)

        const name = ref('')
        const mobile = ref(null) 
        const email = ref('')   
        const note= ref('')   
        const isEmail = ref(false)
        const validationErrors = ref({})
        const submitted = ref(false)
        const abilita_scelta_bimestrale = ref('No')
        const abilita_visualizzazione_generatore_offerte = ref('Si')
        const agente_master = ref('No')
        const id_parent = ref(null)
        const agenti = ref([])
        const fileMandato = ref(null)
        const mandato = ref({
            title: '',
            file: [],
            allowedType: {
                'pdf': 'application/pdf'
            }
        })

        onMounted(() => {
            service.getAgenti().then((res) => {
                agenti.value = res.items || []
            })
            service.getTypeDocumento('man').then((res) => {
                mandato.value.title = res.item?.name || 'MANDATO'
            })
        })

        watch(agente_master, (val) => {
            if (val === 'Si') {
                id_parent.value = null
                delete validationErrors.value.id_parent
            } else {
                mandato.value.file = []
                delete validationErrors.value.mandatoType
            }
        })

        const handleMandatoUpload = (evt) => {
            evt.preventDefault()
            mandato.value.file = evt.target.files ? Array.from(evt.target.files) : []
            delete validationErrors.value.mandatoType
        }

        const nextPage = () => {
            submitted.value = true;
             if (validateForm()) { 
                 const formData = {
                        name: name.value,
                        mobile: mobile.value,
                        email: email.value,
                        note: note.value,
                        abilita_scelta_bimestrale: abilita_scelta_bimestrale.value,
                        abilita_visualizzazione_generatore_offerte: abilita_visualizzazione_generatore_offerte.value,
                        agente_master: agente_master.value,
                        id_parent: agente_master.value === 'No' ? id_parent.value : null,
                        mandato: null
                    }

                 if (agente_master.value === 'Si' && mandato.value.file.length > 0) {
                    formData.mandato = {
                        title: mandato.value.title,
                        file: mandato.value.file,
                        fileName: mandato.value.file[0].name
                    }
                 }

                 emit('next-page', {
                    formData,
                    pageIndex: 0
                });    
             }
        }

        

        const validateForm = () => {
            let regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            if (!name.value.trim())
                validationErrors.value['name'] = true;
            else 
                delete validationErrors.value['name'];

             
            if (email.value != '') {
                if (regex_email.test(email.value)) {
                    delete validationErrors.value['isEmail'];
                } else {
                    validationErrors.value['isEmail'] = true;
                }
            }

            if (agente_master.value === 'No') {
                if (!id_parent.value) {
                    validationErrors.value['id_parent'] = true;
                } else {
                    delete validationErrors.value['id_parent'];
                }
            } else {
                delete validationErrors.value['id_parent'];
            }

            if (agente_master.value === 'Si' && mandato.value.file.length > 0) {
                const allowed = Object.values(mandato.value.allowedType)
                const valid = mandato.value.file.every(file => allowed.includes(file.type))
                if (!valid) {
                    validationErrors.value['mandatoType'] = true;
                } else {
                    delete validationErrors.value['mandatoType'];
                }
            } else {
                delete validationErrors.value['mandatoType'];
            }
            
              
            return !Object.keys(validationErrors.value).length;
        }

        return {
            name,  mobile, email, note, validationErrors, submitted, nextPage, isEmail,
            abilita_scelta_bimestrale, abilita_visualizzazione_generatore_offerte, agente_master,
            id_parent, agenti, mandato, fileMandato, handleMandatoUpload
        }

    },
}
</script>

<style scoped>
.mandato-title {
  margin: 0;
  color: #495057;
}

.mandato-field {
  display: flex;
  flex-direction: column;
}

.mandato-field > label {
  display: block;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.form-file :deep(.mandato-input),
.form-file .button-wrapper,
.form-file .button-wrapper span.label {
  height: 44px !important;
  min-height: 44px !important;
  max-height: 44px !important;
  box-sizing: border-box;
  margin-top: 0;
}

.form-file :deep(.mandato-input) {
  width: 100%;
  line-height: 44px;
  padding-top: 0;
  padding-bottom: 0;
}

.form-file .button-wrapper {
  position: relative;
  width: 100%;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 4px;
  text-align: center;
  line-height: 1.2;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  color: rgb(168, 168, 168);
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 3px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 12px;
}

.form-file .button-wrapper span.label.active {
  color: #2196F3;
  box-shadow: 0 1px 3px rgba(33, 150, 243, 0.35);
}

.form-file #upload-mandato {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>
